import { DsaVersion } from '_gql'
import { formatDate, startOfDay } from 'date-fns'
import { AsYouType, CountryCode, parsePhoneNumber } from 'libphonenumber-js'

import { DSA_VERSION_TYPES } from '@sputnik/resources/constants'

export const getFormattedSsn = (value = '', masked = false) => {
  let v = value?.replace(/[^0-9*]/g, '')?.slice(0, 9)
  if (masked && v.length > 4) {
    v = '*'.repeat(v.length - 4) + v?.slice(-4)
  }
  if (v.length >= 6) {
    return `${v?.slice(0, 3)}-${v?.slice(3, 5)}-${v?.slice(5, 9)}`
  } else if (v.length >= 4) {
    return `${v?.slice(0, 3)}-${v?.slice(3)}`
  }

  return v
}

export const formatPhoneNumberFormField = (phoneNumber, isUsNumber = true) => {
  if (isUsNumber) return new AsYouType('US').input(phoneNumber)
  return new AsYouType().input(phoneNumber)
}

export const getE164FormattedPhoneNumber = (countryCode = 'US', phoneNumber) => {
  if (!phoneNumber) {
    return ''
  }

  try {
    const number = parsePhoneNumber(phoneNumber, countryCode as CountryCode)
    if (number) {
      return number.format('E.164')
    } else {
      return phoneNumber
    }
  } catch {
    return phoneNumber
  }
}

export const getFormattedEIN = (value, masked = false, isSoleProprietorship = false) => {
  if (isSoleProprietorship) {
    return getFormattedSsn(value, masked)
  }
  let v = value?.replace(/[^0-9*]/g, '')
  if (masked && v.length >= 3) {
    v = '*'.repeat(v.length - 4) + v?.slice(-4)
  }
  if (v.length >= 3) {
    return `${v?.slice(0, 2)}-${v?.slice(2)}`
  }

  return v
}

export const epochToDate = (epoch) => {
  if (!epoch) return ''

  const date = new Date(epoch)

  const year = date.getFullYear()

  if (year > 1700) {
    return formatDate(startOfDay(date), 'yyyy-MM-dd')
  }

  return ''
}

export const epochMinutesFromNow = (minutes) => Math.floor(new Date().getTime() / 1000) + minutes * 60

export const getIsDSABusinessOnly = (dsaVersion) => {
  return (
    // these are the types onboarding returns
    dsaVersion === DSA_VERSION_TYPES.CRB_B_O ||
    dsaVersion === DSA_VERSION_TYPES.WEX_B_O ||
    dsaVersion === DSA_VERSION_TYPES.CRB_MC_B_O ||
    dsaVersion === DSA_VERSION_TYPES.WEB_BANK_B_O ||
    // these are the types underwriting returns
    dsaVersion === DsaVersion.CRB_BUSINESS_ONLY ||
    dsaVersion === DsaVersion.CRB_MC_BUSINESS_ONLY ||
    dsaVersion === DsaVersion.WEB_BANK_BUSINESS_ONLY ||
    dsaVersion === DsaVersion.WEX_BUSINESS_ONLY
  )
}

export const getIsDSAWebBank = (dsaVersion) => {
  return (
    // these are the types onboarding returns
    dsaVersion === DSA_VERSION_TYPES.WEB_BANK_PG ||
    dsaVersion === DSA_VERSION_TYPES.WEB_BANK_B_O ||
    // these are the types underwriting returns
    dsaVersion === DsaVersion.WEB_BANK_BUSINESS_ONLY ||
    dsaVersion === DsaVersion.WEB_BANK_PG
  )
}

export const getPaymentNetwork = (dsaVersion) => {
  if (dsaVersion === DSA_VERSION_TYPES.CRB_MC_B_O || dsaVersion === DSA_VERSION_TYPES.CRB_MC_J_S) {
    return 'Mastercard'
  } else {
    return 'Visa'
  }
}

export const limitInputLength = (e, maxLength) => {
  const input = e.target
  input.value = input.value.replace(/[^0-9]/g, '').slice(0, maxLength)
}
